import type { NavigateFunction } from "react-router-dom";
import { homeSectionPath, scrollToHomeSection } from "@/constants/homeSections";

/** Navigate to a home section with a real URL path (e.g. /pricing) for GA page views. */
export function navigateToHomeSection(
  sectionId: string,
  navigate: NavigateFunction,
  currentPathname: string
): void {
  const target = homeSectionPath(sectionId);

  if (currentPathname === target) {
    scrollToHomeSection(sectionId);
    return;
  }

  navigate(target);
}
